import Modal, { ModalFooter, ModalHeader, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';

export type EditLotteryModalProps = {
  visible: boolean;
  onClose: () => void;
  onEdit: () => void;
};

export const EditLotteryModal: React.FC<EditLotteryModalProps> = ({ visible, onClose, onEdit }) => {
  const { t } = useTranslation();
  const editLotteryTitleId = t('general-edit-lottery');

  return (
    <Modal visible={visible} escapable={false} handleCloseBtn={onClose}>
      <Prompt
        aria-labelledby={editLotteryTitleId}
        title={t('lottery-details-edit-modal-header')}
        titleId={editLotteryTitleId}
        header={<ModalHeader ariaCloseTxt={`${t('general-close-prompt')}`} />}
        footer={
          <ModalFooter>
            <Button text={`${t('general-cancel')}`} type="secondary" onClick={onClose} />
            <Button text={`${t('general-edit-lottery')}`} type="primary" onClick={onEdit} />
          </ModalFooter>
        }
      >
        <p>{t('lottery-details-edit-modal-text')}</p>
      </Prompt>
    </Modal>
  );
};
